import React from "react";
import styled from "styled-components";
import Placeholder from "./Placeholder"; 

const Table = ({title, data =[], colours, textColours}) => { 
    let keys = data.length > 0 ? Object.keys(data[0]) : [];

    return(
        <Container>
            <div className="sub-heading">
                <h3> {title} </h3>
            </div>
            {data.length > 0 ? ( 
                <STable>
                <STHead>
                    <STHeadTR>
                        {keys.map((item, index) => (  
                            <STH key={index} style={{fontWeight: "bold"}}>{item}</STH>
                        ))}
                        <STH/>
                    </STHeadTR>
                </STHead>
                <STBody>
                    {data.map((obj, index) => (
                        <STBodyTR key={index} data-rowid={index} > 
                            {keys.map((item, i) => {
                                const value = obj[item];
                                return <STD style={i === 1 ? {backgroundColor: `rgb(${colours[index]})`, color: `${textColours[index]}`}  : {backgroundColor:"0"} }
                                key={i}>{value}</STD>;
                            })}                 
                        </STBodyTR>
                    ))}
                </STBody>
            </STable>
            ) : (
                <Placeholder />
            )}
            
        </Container>
    )
};

export default Table;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .sub-heading {
        padding: 0.5rem;
    }
`;

export const STable = styled.table`
    width: 90%;
    border-collapse: collapse;
    text-align: center;
    overflow: hidden;
    align-items: center;
    justify-content: center;        
    box-shadow: rgba(0, 0, 0, 0.75) 0px 3px 10px;
    border-radius: 5px;
`;

export const STHead = styled.thead`        
    
`;

export const STHeadTR = styled.tr`
    background: #efefef;
`;

export const STH = styled.th`
    font-weight: normal;
    padding: 1rem;
    color: black;
    text-transform: capitalize;
    font-weight: 600;
    font-size: 12px;
`;

export const STBody = styled.tbody``;

export const STBodyTR = styled.tr`
    background: white;
    :hover {
        background-color: #CAD4D1;
    }
`;

export const STD = styled.td`
    padding: 0.3rem;
    font-size: 12px;
`;

export const BTN = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;    
    padding: 1rem;
    button {
        padding: 0.5rem 1rem;
        background-color: #E55B41;
        border: none;
        cursor: pointer;
        color: white;
        border-radius: 0.2rem;
        font-weight: bolder;
        font-size: 1.05rem;
    }
`;